import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: '<app-dashboard-shell></app-dashboard-shell>',
    styles: [':host { display: block; height: 100vh; }'],
    standalone: false
})
export class AppComponent {}
